export default "__VITE_ASSET__DQp6okMW__"